import React from 'react';
import InputField from '../reusable-component/InputField';

function DataQualityIssueResolvePage({ selectedRows }) {
  const { group_id, siemens_pn, description, vendor_pn, id, issue_type } = selectedRows;
  return (
    <div style={{ margin: '16px' }}>
      <InputField
        name="group_id"
        label="Group Id"
        value={group_id}
        // onChange={handleInputChange}
        size="small"
        disabled
        required
        style={{ width: '25%' }}
      />
    </div>
  );
}

export default DataQualityIssueResolvePage;
